module.exports = __webpack_public_path__ + "static/bf-stories-53c266c867546b2b66de4aa6f1aa37ae.mp4";